import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { BillingUnitModuleModel } from '../billing-unit-module.model';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import { AppTextService } from '@fi-shared/app-text';

@Component({
    selector: 'fi-billing-unit-view',
    templateUrl: './billing-unit-view.component.html',
    styleUrls: ['./billing-unit-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-billing-unit-view' },
    standalone: false,
})
export class BillingUnitViewComponent implements OnInit {
    @Input() unitModule: BillingUnitModuleModel;
    editTabs: EditTabsModel;

    constructor(
        private fiStateService: FiStateService,
        private appTextService: AppTextService,
    ) {}

    ngOnInit() {
        this.setPageHeaderData();
    }

    private setPageHeaderData() {
        this.editTabs = new EditTabsModel(this.unitModule.ModuleTypeName, this.appTextService.get('back'));
    }

    editUnitBilling() {
        this.fiStateService.go(FiStateNames.Billing.Unit.Edit, {
            ModuleType: this.unitModule.ModuleType,
            UnitId: this.unitModule.BusinessUnitId,
        });
    }
}
